// extracted by mini-css-extract-plugin
export default {"safeArea":"SafeArea_safeArea__OTqMX","safeArea-position-top":"SafeArea_safeArea-position-top__jXvBZ","safeArea-position-bottom":"SafeArea_safeArea-position-bottom__5sg79"};